declare const process: { env: Record<string, string | undefined> };

export const LLM_MODEL: string = process.env.REACT_APP_LLM_MODEL ?? "gpt-5.4";
export const LLM_TOOL_SELECTION_MODEL: string = process.env.REACT_APP_LLM_TOOL_SELECTION_MODEL ?? LLM_MODEL;
export const INCIDENT_LLM_MODEL: string = process.env.REACT_APP_INCIDENT_LLM_MODEL ?? "gpt-5";
// export const ASSIGNMENT_GROUP_LLM_MODEL: string = process.env.REACT_APP_ASSIGNMENT_GROUP_LLM_MODEL ?? "gpt-5";
export const USE_GEMINI_FLOW: boolean = LLM_MODEL.toLowerCase().includes("gemini");
export const AZURE_API_VERSION: string = process.env.REACT_APP_AZURE_API_VERSION ?? "2024-02-01";
